import React, { FC } from 'react';

import {
  DataTable,
  List,
} from 'react-admin';

import { useTitle } from '@src/hooks';
import { PluginConfigVersion } from '@troverecommerce/ps-configs-api-client';

import {
  ConfigVersionCurrentBadge,
  ConfigVersionDateTimeField,
} from '../shared';

interface IConfigVersionListProps {
  label: string;
}

const ConfigVersionList: FC<IConfigVersionListProps> = ({ label }) => {
  const { title } = useTitle(label);
  return (
    <List
      title={title}
      sort={{ field: 'isDefault', order: 'DESC' }}
    >
      <DataTable bulkActionButtons={false} rowClick="edit">
        <DataTable.Col
          label="Name"
          source="name"
        />
        <DataTable.Col
          label="ID"
          source="id"
        />
        <DataTable.Col
          label="Config created at"
          source="createdAt"
        >
          <ConfigVersionDateTimeField source="createdAt" />
        </DataTable.Col>
        <DataTable.Col
          label="Config updated at"
          source="updatedAt"
        >
          <ConfigVersionDateTimeField source="updatedAt" />
        </DataTable.Col>
        <DataTable.Col
          label="Settings updated at"
          source="settingsUpdatedAt"
        >
          <ConfigVersionDateTimeField source="settingsUpdatedAt" />
        </DataTable.Col>
        <DataTable.Col
          label="Is Current"
          source="isDefault"
          render={({ isDefault }: PluginConfigVersion) => isDefault && <ConfigVersionCurrentBadge />}
        />
      </DataTable>
    </List>
  );
};

export default ConfigVersionList;
